export const updateModellIndexVordaecher = ev => {
    return {
        type: 'UPDATEMODELLINDEXVORDAECHER',
        ev: ev
    }
}

export const updateWidthVordaecher = ev => {
    return {
        type: 'UPDATEWIDTHVORDAECHER',
        ev: ev
    }
}

export const updateWrapperIndexVordaecher = ev => {
    return {
        type: 'UPDATEWRAPPERINDEXVORDAECHER',
        ev: ev
    }
}

export const updadteHeightVordaecher = ev => {
    return {
        type: 'UPDATEHEIGHTVORDAECHER',
        ev: ev
    }
}

export const updateStepsVordaecher = ev => {
    return {
        type: 'UPDATESTEPSVORDAECHER',
        ev: ev
    }
}

export const updateAllVisitedStepsVordaecher = () => {
    return {
        type: 'UPDATEALLVISITEDSTEPSVORDAECHER'
    }
}

export const updateGlasartVordaecher = ev => {
    return {
        type: 'UPDATEGLASARTVORDAECHER',
        ev: ev
    }
}

export const updateProductToMerklisteVordaecher = ev => {
    return {
        type: 'UPDATEPRODUCTTOMERKLISTEVORDAECHER',
        ev: ev
    }
}

export const updateDescriptionVordaecher = ev => {
    return {
        type: 'UPDATEDESCRIPTIONVORDAECHER',
        ev: ev
    }
}

export const selectUploadDataVordaecher = ev => {
    return {
        type: 'SELECTUPLOADDATAVORDAECHER',
        ev: ev
    }
}

export const selectPfostenVordaecher = ev => {
    return {
        type: 'SELECTPFOSTENVORDAECHER',
        ev: ev
    }
}

export const selectImageCategory = ev => {
    return {
        type: 'SELECTIMAGECATEGORY',
        ev: ev
    }
}

